import { TeamMemberDTO } from "../../models/team-member/team-member-dto";
import { TeamMemberSTO } from "../../models/team-member/team-member-sto";
import { BaseApiService } from "../base";

export class TeamMembersApiService extends BaseApiService<TeamMemberDTO, TeamMemberSTO> {
  constructor() {
    super({
      servicePath: "/TeamMembers",
      loadItemsPath: "/GetTeamMembers",
      saveItemsPath: "/SaveTeamMembers",
    });
  }
}
